<div class="field-input-container" [class.panel-mode]="panelTab || compactMode">

    <form [formGroup]="seasonInputForm">

        <div [hidden]="panelTab && panelTab !== 'field'">
        <p class="details-heading-text" *ngIf="!panelTab">Field Data</p>

         <div class="field-input-row">

            <div [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs" >
                <mat-slide-toggle formControlName="isHarvested"
                                  (change)="onToggleIrrigation($event)"
                >Harvested</mat-slide-toggle>
            </div>


            <div [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  *ngIf="isHidden">
                <mat-slide-toggle formControlName="allowNotifications"
                                  (change)="onToggleAllowNotifications($event)"
                >Allow notifications</mat-slide-toggle>
            </div>

            <div [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  *ngIf="!isHidden">
                <mat-slide-toggle formControlName="allowNotifications"
                                  (change)="onToggleAllowNotifications($event)"
                >Allow notifications</mat-slide-toggle>
            </div>
        </div>

        <div class="field-input-row">
            <mat-form-field  [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline">
                <mat-label appRemoveAriaOwns> Field Type</mat-label>
                <mat-select formControlName="fieldType">
                    <mat-option *ngFor="let type of types" [value]="type.id" (click)="toggleType()">
                        {{type?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" (keyup)="fieldNameUpdate($event.target.value)" *ngIf="isHidden">
                <mat-label>Field Name</mat-label>
                <input matInput formControlName="fieldName">
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" (keyup)="fieldNameUpdate($event.target.value)" *ngIf="isInputVisible && !isHidden">
                <mat-label>Field Name</mat-label>
                <input matInput formControlName="fieldName">
            </mat-form-field>

            <div [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  *ngIf="isHidden">
                <div class="hectare-text-container">
                    <p class="hectare-text-header">Field Size:</p>
                    <p class="hectare-text-sub">{{fieldSize ? fieldSize : placeholder}} HA</p>
                </div>
            </div>

            <div [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  *ngIf="isInputVisible && !isHidden">
                <div class="hectare-text-container">
                    <p class="hectare-text-header">Field Size:</p>
                    <p class="hectare-text-sub">{{fieldSize ? fieldSize : placeholder}} HA</p>
                </div>
            </div>

            <!-- <div [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  *ngIf="isHidden">
                <mat-slide-toggle formControlName="allowNotifications"
                                  (change)="onToggleAllowNotifications($event)"
                >Allow notifications</mat-slide-toggle>
            </div>

            <div [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  *ngIf="!isHidden">
                <mat-slide-toggle formControlName="allowNotifications"
                                  (change)="onToggleAllowNotifications($event)"
                >Allow notifications</mat-slide-toggle>
            </div> -->

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline">
                <mat-label>Plant Date</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="plantDate">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline">
                <mat-label appRemoveAriaOwns>Current Crop</mat-label>
                <mat-select formControlName="currentCrop">
                    <mat-option style="background-color: white!important; padding: 6px!important;">
                        <div class="select-search-container-lrg">
                            <div class="select-search-lrg">
                                <ngx-mat-select-search placeholderLabel="Search Crops" [formControl]="cropFilterCtrl">
                            <span ngxMatSelectNoEntriesFound>
                                No Crops Found
                            </span>
                                </ngx-mat-select-search>
                            </div>
                        </div>
                    </mat-option>
                    <mat-option *ngFor="let crop of filteredCropsList" [value]="crop.id">
                        {{crop?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline">
                <mat-label>Cultivar</mat-label>
                <input matInput formControlName="cultivar">
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs cultivar-size-field"  appearance="outline">
                <mat-label>Cultivar Size (ha)</mat-label>
                <input matInput type="number" step="0.01" min="0" formControlName="cultivarSize">
                <mat-error *ngIf="seasonInputForm.controls.cultivarSize.hasError('min')">Value must be 0 or greater</mat-error>
                <mat-error *ngIf="!seasonInputForm.controls.cultivarSize.hasError('min') && seasonInputForm.controls.cultivarSize.hasError('pattern')">Maximum 2 decimal places</mat-error>
                <mat-error *ngIf="!seasonInputForm.controls.cultivarSize.hasError('min') && !seasonInputForm.controls.cultivarSize.hasError('pattern') && seasonInputForm.controls.cultivarSize.hasError('cultivarSizeSum')">{{ seasonInputForm.controls.cultivarSize.getError('cultivarSizeSum') }}</mat-error>
            </mat-form-field>

            <!-- <div [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs" >
                <mat-slide-toggle formControlName="isHarvested"
                                  (change)="onToggleIrrigation($event)"
                >Harvested</mat-slide-toggle>
            </div> -->

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline">
                <mat-label>Yield Average</mat-label>
                <input matInput formControlName="yieldAverage"
                       oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline">
                <mat-label>Yield Goal</mat-label>
                <input matInput formControlName="yieldGoal"
                       oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            </mat-form-field>

            <div [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline">
                <mat-slide-toggle formControlName="isIrrigation"
                                  (change)="onToggleIrrigation($event)"
                >Irrigation</mat-slide-toggle>
            </div>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline">
                <mat-label>Expected Water Amount</mat-label>
                <input matInput formControlName="expectedWaterAmount"
                       oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline">
                <mat-label appRemoveAriaOwns> Irrigation Type</mat-label>
                <mat-select formControlName="irrigationType">
                    <mat-option *ngFor="let irgType of irrigationType"  [value]="irgType.id">
                        {{irgType?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

<!--            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isFruit || isOrchardVineyard">-->
<!--                <mat-label appRemoveAriaOwns> Crop Code</mat-label>-->
<!--                <mat-select formControlName="cropCode">-->
<!--                    <mat-option *ngFor="let crop of crops" [value]="crop.id">-->
<!--                        {{crop?.description ?? placeholder}}-->
<!--                    </mat-option>-->
<!--                </mat-select>-->
<!--            </mat-form-field>-->

            <!-- Notes: a plain textarea rather than mat-form-field, matching the pattern
                 used by create-edit-season and lab-submission-detail. A textarea inside
                 mat-form-field cannot be height-controlled from this stylesheet, because
                 the outline is rendered by MatFormField's own template and is therefore
                 out of reach of emulated encapsulation. Every other textarea in this app
                 is plain for the same reason. -->
            <div class="season-field-notes">
                <p class="text-[12px] font-semibold text-[var(--base-text-alt-dark)] mb-1.5">Notes</p>
                <textarea formControlName="notes" maxlength="1000" placeholder="Add notes..."
                    class="w-full h-[120px] py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[12px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)] resize-y font-[Poppins]"></textarea>
                <p class="text-[11px] text-right text-[var(--base-text-alt-dark)] mt-0.5 mb-0">
                    {{ seasonInputForm.controls.notes.value?.length || 0 }}/1000
                </p>
            </div>

</div>


<hr *ngIf="isFruit || isOrchardVineyard || isVegetables || isGrainAndFeed" style=" border-top: 1px solid #e0dfdf; margin-top: 10px; margin-bottom: 10px;">
</div>
<div [hidden]="panelTab && panelTab !== 'crop'">
<p *ngIf="isFruit || isOrchardVineyard || isVegetables || isGrainAndFeed"class="details-heading-text">{{ currentFieldTypeName }}</p>
<div class="field-input-row">
<!-- Exstra Field Details / Fruit / Vegetable / Vinyard / Grain & Feed -->



            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isFruit || isOrchardVineyard">
                <mat-label>Vigor:  (1) weak / (5) strong</mat-label>
                    <input matInput formControlName="growthPower"
                            oninput="if (this.value.length > 4) this.value = this.value.slice(1, 4); 
                            var parts = this.value.split('.'); 
                            parts[0] = parts[0].replace(/[^0-9]/g, ''); 
                            if(parts[1]){parts[1] = parts[1].slice(0, 1); }
                            this.value = parts.join('.'); 
                            if (parseFloat(this.value) > 5) this.value = 5;"
                       >
                <!-- <input matInput formControlName="growthPower"
                       oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8"> -->
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isVegetables || isGrainAndFeed">
                <mat-label appRemoveAriaOwns> Previous Crop</mat-label>
                <mat-select formControlName="previousCrop">
                    <mat-option *ngFor="let crop of crops | orderByDescription: 'description'" [value]="crop.id">
                        {{crop?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isVegetables || isGrainAndFeed">
                <mat-label appRemoveAriaOwns> Tillage/Ground Prep Type</mat-label>
                <mat-select formControlName="tillage">
                    <mat-option *ngFor="let tile of tillage" [value]="tile.id">
                        {{tile?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isVegetables">
                <mat-label appRemoveAriaOwns> Harvested Residues</mat-label>
                <mat-select formControlName="harvestResidues">
                    <mat-option *ngFor="let harvestRes of harvestResidues" [value]="harvestRes.id">
                        {{harvestRes?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isGrainAndFeed">
                <mat-label>Bearing/Years After Pod</mat-label>
                <input matInput formControlName="bearing"
                       oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isGrainAndFeed">
                <mat-label appRemoveAriaOwns> Pod Effectiveness</mat-label>
                <mat-select formControlName="podEffectiveness">
                    <mat-option *ngFor="let podEf of podEffectiveness" [value]="podEf.id">
                        {{podEf?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isGrainAndFeed">
                <mat-label appRemoveAriaOwns> Harvest Residues</mat-label>
                <mat-select formControlName="harvestResidues">
                    <mat-option *ngFor="let harvestRes of harvestResidues" [value]="harvestRes.id">
                        {{harvestRes?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isGrainAndFeed">
                <mat-label appRemoveAriaOwns> Plant Spread</mat-label>
                <mat-select formControlName="plantSpread">
                    <mat-option *ngFor="let plant of plantSpread" [value]="plant.id">
                        {{plant?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isGrainAndFeed || isVegetables">
                <mat-label appRemoveAriaOwns> Plant Action</mat-label>
                <mat-select formControlName="plantAction">
                    <mat-option *ngFor="let plantAct of plantAction" [value]="plantAct.id">
                        {{plantAct?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isVegetables">
                <mat-label>Plant Density</mat-label>
                <input matInput formControlName="plantDensity"
                       oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline"  *ngIf="isGrainAndFeed">
                <mat-label>Track Width (mm)</mat-label>
                <input matInput formControlName="trackWidth"
                       oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isGrainAndFeed">
                <mat-label appRemoveAriaOwns> Fertilizer Placement</mat-label>
                <mat-select formControlName="fertilizerPlacement">
                    <mat-option *ngFor="let fertPlace of fertilizerPlacement" [value]="fertPlace.id">
                        {{fertPlace?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isVegetables">
                <mat-label appRemoveAriaOwns> Fertilizer Placement  With Planting</mat-label>
                <mat-select formControlName="fertilizerPlacementWithPlanting">
                    <mat-option *ngFor="let fertPlace of fertilizerPlacementWithPlanting" [value]="fertPlace.id">
                        {{fertPlace?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isVegetables || isFruit || isOrchardVineyard">
                <mat-label appRemoveAriaOwns>Fertilizer Type</mat-label>
                <mat-select formControlName="fertilizerType">
                    <mat-option *ngFor="let fertType of fertilizerType" [value]="fertType.id">
                        {{fertType?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isFruit || isOrchardVineyard">
                <mat-label>Plant Year</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="plantYear">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <!-- NEW FIELDS: Fruit & Vineyard -->
            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}" class="season-field-inputs" appearance="outline" *ngIf="isFruit || isOrchardVineyard">
                <mat-label>Full Bloom Date</mat-label>
                <input matInput [matDatepicker]="fullBloomPicker" formControlName="fullBloomDate">
                <mat-datepicker-toggle matIconSuffix [for]="fullBloomPicker"></mat-datepicker-toggle>
                <mat-datepicker #fullBloomPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}" class="season-field-inputs" appearance="outline" *ngIf="isFruit || isOrchardVineyard">
                <mat-label>Row Spacing (m)</mat-label>
                <input matInput formControlName="rowSpacing" oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}" class="season-field-inputs" appearance="outline" *ngIf="isFruit || isOrchardVineyard">
                <mat-label>Plant Spacing (m)</mat-label>
                <input matInput formControlName="plantSpacing" oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}" class="season-field-inputs" appearance="outline" *ngIf="isFruit || isOrchardVineyard">
                <mat-label>Replant Date</mat-label>
                <input matInput [matDatepicker]="replantPicker" formControlName="replantDate">
                <mat-datepicker-toggle matIconSuffix [for]="replantPicker"></mat-datepicker-toggle>
                <mat-datepicker #replantPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}" class="season-field-inputs" appearance="outline" *ngIf="isFruit || isOrchardVineyard">
                <mat-label>Bud Break Date</mat-label>
                <input matInput [matDatepicker]="budBreakPicker" formControlName="budBreakDate">
                <mat-datepicker-toggle matIconSuffix [for]="budBreakPicker"></mat-datepicker-toggle>
                <mat-datepicker #budBreakPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}" class="season-field-inputs" appearance="outline" *ngIf="isFruit || isOrchardVineyard">
                <mat-label>Budding Date</mat-label>
                <input matInput [matDatepicker]="buddingPicker" formControlName="buddingDate">
                <mat-datepicker-toggle matIconSuffix [for]="buddingPicker"></mat-datepicker-toggle>
                <mat-datepicker #buddingPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}" class="season-field-inputs" appearance="outline" *ngIf="isFruit || isOrchardVineyard">
                <mat-label>Rootstock</mat-label>
                <input matInput formControlName="rootstock" maxlength="100">
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}" class="season-field-inputs" appearance="outline" *ngIf="isOrchardVineyard">
                <mat-label>Plants per Hectare</mat-label>
                <input matInput formControlName="plantsPerHectare" oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isVegetables">
                <mat-label appRemoveAriaOwns> Method of Top Dressing</mat-label>
                <mat-select formControlName="methodOfTopDressing">
                    <mat-option *ngFor="let mOfTopDress of methodOfTopDressing" [value]="mOfTopDress.id">
                        {{mOfTopDress?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isVegetables">
                <mat-label appRemoveAriaOwns> Type of Top Dressing Fertilizer</mat-label>
                <mat-select formControlName="typeOfTopDressingFertilizer">
                    <mat-option *ngFor="let typeOfTopDres of typeOfTopDressingFertilizer" [value]="typeOfTopDres.id">
                        {{typeOfTopDres?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isVegetables">
                <mat-label appRemoveAriaOwns> Water Quality EC mS/m</mat-label>
                <mat-select formControlName="waterQualityEc">
                    <mat-option *ngFor="let waterQual of waterQualityEcId"  [value]="waterQual.id">
                        {{waterQual?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isVegetables">
                <mat-label>Time Lime Applied (Recently)</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="timeLimeApplied">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isVegetables">
                <mat-label>t/Ha Lime Applied (Recently)</mat-label>
                <input matInput formControlName="tHaLimeApplied"
                       oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            </mat-form-field>

            <!-- NEW FIELDS: Vegetables -->
            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}" class="season-field-inputs" appearance="outline" *ngIf="isVegetables">
                <mat-label>Full Bloom Date</mat-label>
                <input matInput [matDatepicker]="vegFullBloomPicker" formControlName="fullBloomDate">
                <mat-datepicker-toggle matIconSuffix [for]="vegFullBloomPicker"></mat-datepicker-toggle>
                <mat-datepicker #vegFullBloomPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}" class="season-field-inputs" appearance="outline" *ngIf="isVegetables">
                <mat-label>Row Spacing (m)</mat-label>
                <input matInput formControlName="rowSpacing" oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}" class="season-field-inputs" appearance="outline" *ngIf="isVegetables">
                <mat-label>Plant Spacing (m)</mat-label>
                <input matInput formControlName="plantSpacing" oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}" class="season-field-inputs" appearance="outline" *ngIf="isVegetables">
                <mat-label>Replant Date</mat-label>
                <input matInput [matDatepicker]="vegReplantPicker" formControlName="replantDate">
                <mat-datepicker-toggle matIconSuffix [for]="vegReplantPicker"></mat-datepicker-toggle>
                <mat-datepicker #vegReplantPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}" class="season-field-inputs" appearance="outline" *ngIf="isVegetables">
                <mat-label>Rising Date</mat-label>
                <input matInput [matDatepicker]="risingPicker" formControlName="risingDate">
                <mat-datepicker-toggle matIconSuffix [for]="risingPicker"></mat-datepicker-toggle>
                <mat-datepicker #risingPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}" class="season-field-inputs" appearance="outline" *ngIf="isVegetables">
                <mat-label>Plants per Hectare</mat-label>
                <input matInput formControlName="plantsPerHectare" oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isGrainAndFeed">
                <mat-label appRemoveAriaOwns> Plant Fertilizer Type</mat-label>
                <mat-select formControlName="plantFertilizerType">
                    <mat-option *ngFor="let plantFertType of plantFertilizerType" [value]="plantFertType.id">
                        {{plantFertType?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isGrainAndFeed">
                <mat-label appRemoveAriaOwns> Top Dressing Method</mat-label>
                <mat-select formControlName="topDressingMethod">
                    <mat-option *ngFor="let topDressMethod of topDressingMethod" [value]="topDressMethod.id">
                        {{topDressMethod?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isGrainAndFeed">
                <mat-label appRemoveAriaOwns> Type of Fertilizer (BOB1)</mat-label>
                <mat-select formControlName="typeOfFertilizerBobOne">
                    <mat-option *ngFor="let typeBobOne of typeOfFertilizerBob" [value]="typeBobOne.id">
                        {{typeBobOne?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="isGrainAndFeed">
                <mat-label appRemoveAriaOwns> Type of Fertilizer(BOB2)</mat-label>
                <mat-select formControlName="typeOfFertilizerBobTwo">
                    <mat-option *ngFor="let typofBob of typeOfFertilizerBob" [value]="typofBob.id">
                        {{typofBob?.description ?? placeholder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

<!--            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline"  *ngIf="hide">-->
<!--                <input matInput formControlName="fieldId">-->
<!--            </mat-form-field>-->

<!--            <mat-form-field [ngClass]="{'form-field-season-custom': isViewedFromSeasonAdmin}"  class="season-field-inputs"  appearance="outline" *ngIf="hide">-->
<!--                <input matInput formControlName="detailsId">-->
<!--            </mat-form-field>-->

        </div>

<!-- Cost Section (hidden in batch update view where no real field is loaded) -->
</div>
<div [hidden]="panelTab && panelTab !== 'cost'">
<ng-container *ngIf="inputData?.fieldId">
<hr style="border-top: 1px solid #e0dfdf; margin-top: 10px; margin-bottom: 10px;">
<p class="details-heading-text">Fixed Cost</p>
<div class="cost-container">

    <!-- Fixed Input Cost (always shown) -->
    <div class="cost-fixed-row">
        <mat-form-field class="cost-field-input" appearance="outline">
            <mat-label>Fixed input cost</mat-label>
            <input matInput type="number" [(ngModel)]="fixedCostValue" [ngModelOptions]="{standalone: true}"
                   (blur)="onFixedCostBlur()" min="0" max="1000000">
        </mat-form-field>
    </div>

    <!-- Two column layout: VRT left, As Applied right -->
    <div class="cost-columns">
        <!-- VRT Column -->
        <div class="cost-column">
            <p class="cost-column-heading">VRT</p>
            <div class="cost-scroll-container">
                <div class="cost-grid">
                    <div *ngFor="let vrt of vrtMapTypes" class="cost-pair">
                        <mat-form-field class="cost-field-input" appearance="outline">
                            <mat-label>{{ vrt.type }}</mat-label>
                            <input matInput type="number" [(ngModel)]="vrt.costValue" [ngModelOptions]="{standalone: true}"
                                   (blur)="onCostBlur(vrt, 'VRT')" min="0" max="1000000">
                        </mat-form-field>
                        <mat-form-field class="cost-field-uom" appearance="outline">
                            <mat-label appRemoveAriaOwns>Unit</mat-label>
                            <mat-select [(ngModel)]="vrt.unitOfMeasureId" [ngModelOptions]="{standalone: true}"
                                        (selectionChange)="onCostBlur(vrt, 'VRT')">
                                <mat-option *ngFor="let uom of unitsOfMeasure" [value]="uom.id">{{ uom.description }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div *ngIf="vrtMapTypes.length === 0" class="cost-no-data-col">No VRT cost options available.</div>
            </div>
        </div>

        <!-- As Applied Column -->
        <div class="cost-column">
            <p class="cost-column-heading">As Applied</p>
            <div class="cost-scroll-container">
                <div class="cost-grid">
                    <div *ngFor="let aa of asAppliedMapTypes" class="cost-pair">
                        <mat-form-field class="cost-field-input" appearance="outline">
                            <mat-label>{{ aa.type }}</mat-label>
                            <input matInput type="number" [(ngModel)]="aa.costValue" [ngModelOptions]="{standalone: true}"
                                   (blur)="onCostBlur(aa, 'ASAPPLIED')" min="0" max="1000000">
                        </mat-form-field>
                        <mat-form-field class="cost-field-uom" appearance="outline">
                            <mat-label appRemoveAriaOwns>Unit</mat-label>
                            <mat-select [(ngModel)]="aa.unitOfMeasureId" [ngModelOptions]="{standalone: true}"
                                        (selectionChange)="onCostBlur(aa, 'ASAPPLIED')">
                                <mat-option *ngFor="let uom of unitsOfMeasure" [value]="uom.id">{{ uom.description }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div *ngIf="asAppliedMapTypes.length === 0" class="cost-no-data-col">No As Applied cost options available.</div>
            </div>
        </div>
    </div>

</div>
</ng-container>
</div>

    </form>

</div>
<!-- <hr style=" border-top: 1px solid #e0dfdf;"> -->
